import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { ExchangeAction } from '../../actions';
import { bindActionCreators } from 'redux';
import Wrapper from './style';
import {
	getCollateral,
	notificationExchange,
	putExchange
} from '../../common/fetch';
import { CLOUD_ICON, SETUP_MASTER } from '../../config/media';
import { HOLLAEX_KIT } from '../../config/constants';

class SetupModal extends Component {
	state = {
		exchange: {},
		isLoaded: false,
		id: 0
	};

	componentDidMount() {
		this.getData();
		this.updateCompleteExchange();
	}

	getData = async () => {
		const { biz, location } = this.props;
		let id = 0;
		if (location.search === '') {
			id = biz.id;
		} else {
			id = location.search.split('=')[1];
		}
		try {
			const res = await getCollateral(id);
			this.setState({
				exchange: res.data,
				isLoaded: true,
				id
			});
		} catch (error) {
			console.error(error);
		}
	};

	updateCompleteExchange = async () => {
		const { biz, exch } = this.props;
		const exchange = exch.filter((item) => biz.id === item.id);
		const body = {
			is_completed: true
		};
		if (exchange.length > 0) {
			body.id = exchange[0].id;
		} else {
			body.id = biz.id;
		}
		try {
			await notificationExchange(body.id);
		} catch (error) {
			console.error(error);
		}
		try {
			await putExchange(body);
			this.getExchanges(biz.id);
		} catch (error) {
			console.error(error);
			this.getExchanges(biz.id);
		}
	};

	getExchanges = async (id) => {
		const exchange = this.props.exch.map((item) => {
			if (item.id === id) {
				item.is_completed = true;
			}
			return item;
		});
		this.props.actions.readData(exchange);
	};

	render() {
		const { isOpen, onCancel, onOk, desc, biz } = this.props;
		const { id } = this.state;

		return (
			<Modal
				visible={isOpen}
				onCancel={onCancel}
				onOk={onOk}
				// title="Congratulations!"
				footer={null}
			>
				<Wrapper>
					<div className="cloud-wrapper">
						<img src={CLOUD_ICON} alt="cloud" className="cloud-icon" />
						<h2>Cloud Exchange Selected</h2>
					</div>
					<div className="desc-container">
						<img src={SETUP_MASTER} alt="icon" className="anticon" />
						{desc === 'biz' ? (
							<p>
								"You've complete the general setup!
								<br />
								The next step is setting up where
								<br />
								your exchange lives. This part can be
								<br />
								tricky but I'm here to help you
								<br />
								setup your exchange server. If you
								<br />
								require assistance just let me know."
								<br />
							</p>
						) : desc === 'on-premise' ? (
							<div>
								<div className="talking-bubble">
									You have finished the initial exchange setup for <b>{biz.EXCHANGE_NAME}</b>. An email has been sent with instructions of what to do next or you can just follow the steps below.
								</div>
								<ol style={{ paddingLeft: '12px' }}>
									<li>
										<a href={HOLLAEX_KIT} title="download" download>
											Download the Kit
										</a>
										<br />
										(this should download the github repo)
									</li>
									<li>
										<a
											href="https://docs.hollaex.com/"
											title="docs"
											target="_blank"
											rel="noopener noreferrer"
										>
											Install
										</a>
										{' '}the kit following the docs
									</li>
									<li>
										<a
											href="https://docs.hollaex.com/get-started/setup"
											target="_blank"
											rel="noopener noreferrer"
											title="run"
										>
											Run your Exchange!
										</a>
									</li>
									{/*<li>Collateralize XHT</li>*/}
									<li>On board your users and profit!</li>
								</ol>
								<div>
									Need help? Invite a tech guy to help get your
										exchange up on the server by{' '}
									<Link
										to={
											id === 0
												? '/exchange/member'
												: '/exchange/member?id=' + id
										}
									>
										inviting them here
										</Link>
								</div>
							</div>
						) : (
									<div>
										<div className="talking-bubble">
											You have finished the initial exchange setup for <b>{biz.EXCHANGE_NAME}</b>. An email has been sent with instructions of what to do next. In order to get your exchange online you are required to finish exchange configurations and settle your hosting bill.
										</div>
										{/* <ol style={{ paddingLeft: '12px' }}>
											<li>
												Settle cloud exchange <Link to={'/billing'}>hosting bill</Link>
											</li>
											<li>Login to your exchange</li>
											<li>Customize your exchange</li>
											<li>On board users and profit!</li>
										</ol> */}
										{/* <div>
											Need help? Invite a tech guy to help get your
											exchange up on the server by{' '}
											<Link
												to={
													id === 0
														? '/exchange/member'
														: '/exchange/member?id=' + id
												}
											>
												inviting them here
											</Link>
										</div> */}
									</div>
								)}
					</div>
					<Button block type="primary" onClick={onOk}>
						Okay
					</Button>
					{/* <div className="disclamar">
						<p>
							To get more information on what to do next visit our&nbsp;
							<Link to="/help">help section.</Link>
						</p>
					</div> */}
				</Wrapper>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		biz: state.setup.biz,
		tech: state.setup.tech,
		exch: state.exchange
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(ExchangeAction, dispatch)
});

const wrappedModal = withRouter(SetupModal);

export default connect(mapStateToProps, mapDispatchToProps)(wrappedModal);
